import { MVUAction } from 'common/MVUAction';
import { AdditionalContact } from 'components/ProviderData/IpaAdministration/atoms/Models';

export interface ClaimDepartmentTabState {
    loading: boolean;
    contact: AdditionalContact | null;
    isDirty: boolean;
    additionalContacts: any;
}

export const initialClaimDepartmentTabState: ClaimDepartmentTabState = {
    loading: false,
    contact: null,
    isDirty: false,
    additionalContacts: [],
};

interface Loading extends MVUAction<boolean> {
    type: 'Loading';
}

interface Contact extends MVUAction<AdditionalContact | null> {
    type: 'Contact';
}

interface IsDirty extends MVUAction<boolean> {
    type: 'IsDirty';
}

interface AdditionalContacts extends MVUAction<any> {
    type: 'AdditionalContacts';
}

type ClaimDepartmentTabActions = Loading | Contact | IsDirty | AdditionalContacts;

export const updateClaimDepartmentTabState = (
    state: ClaimDepartmentTabState,
    action: ClaimDepartmentTabActions,
): ClaimDepartmentTabState => {
    switch (action.type) {
        case 'Loading':
            return { ...state, loading: action.payload };
        case 'Contact':
            return { ...state, contact: action.payload };
        case 'IsDirty':
            return { ...state, isDirty: action.payload };
        case 'AdditionalContacts':
            return { ...state, additionalContacts: action.payload };
        default:
            return state;
    }
};
